import React from "react";
import { ShieldCheck } from "lucide-react";

// Strong, professional FIAD certification badge.
export default function FiadBadge({ testId = "fiad-badge", compact = false }) {
  return (
    <div
      data-testid={testId}
      className={`relative bg-[#0A0A0A] text-white rounded-sm border border-[#0A0A0A] overflow-hidden ${compact ? "px-6 py-6" : "px-8 py-10"}`}
    >
      {/* subtle corner rule accents */}
      <span className="absolute top-3 left-3 h-4 w-4 border-t border-l border-white/25" />
      <span className="absolute top-3 right-3 h-4 w-4 border-t border-r border-white/25" />
      <span className="absolute bottom-3 left-3 h-4 w-4 border-b border-l border-white/25" />
      <span className="absolute bottom-3 right-3 h-4 w-4 border-b border-r border-white/25" />

      <div className="flex flex-col items-center text-center">
        <div className="h-12 w-12 rounded-full border border-white/30 flex items-center justify-center mb-4">
          <ShieldCheck className="h-6 w-6 text-white" strokeWidth={1.5} />
        </div>
        <span className="font-display text-2xl font-extrabold tracking-[0.2em]">FIAD</span>
        <div className="mt-2 h-px w-16 bg-white/25" />
        <span className="mt-3 text-xs font-semibold uppercase tracking-[0.3em] text-white/80">Vetted Expert</span>
        <span className="mt-2 text-sm font-medium text-white">Bengali Language Evaluation</span>
      </div>
    </div>
  );
}
